import { useMediaQuery, useTheme } from "@mui/material"
import { MOBILE_BREAKPOINT } from "./constants"
import DashboardDesktop from "./DashboardDesktop"
import DashboardErrorBoundary from "./DashboardErrorBoundary"
import DashboardMobile from "./DashboardMobile"

const Dashboard = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(MOBILE_BREAKPOINT))

  return isMobile ? <DashboardMobile /> : <DashboardDesktop />
}

// Main component wrapped with error boundary
const DashboardWithErrorBoundary = () => (
  <DashboardErrorBoundary>
    <Dashboard />
  </DashboardErrorBoundary>
)

export default DashboardWithErrorBoundary
